import Vue from 'vue';
import axios from 'axios';
import OSREC from 'currencyformatter.js/dist/currencyFormatter.js';
import moment from "moment";

export default {
    install(Vue, options) {
        Vue.prototype.$axios                    = axios;
        Vue.prototype.$API_URL                  = process.env.API_URL;
        Vue.prototype.$storageURL               = process.env.STORAGE_URL;
        Vue.prototype.$SignUp                   = process.env.API_URL + 'api/signup';
        Vue.prototype.$NumberVerify             = process.env.API_URL + 'api/send-verification-code';
        Vue.prototype.$ResendVerificationCode   = process.env.API_URL + 'api/reSend-verification-code';
        Vue.prototype.$VerifyAccount            = process.env.API_URL + 'api/verify-account';
        Vue.prototype.$Login                    = process.env.API_URL + 'api/login';
        Vue.prototype.$SupportLogin                    = process.env.API_URL + 'api/support-login';
        Vue.prototype.$Logout                   = process.env.API_URL + 'api/logout';
        Vue.prototype.$Forgotpassword           = process.env.API_URL + 'api/forget-password-request';
        Vue.prototype.$showcompanies            = process.env.API_URL + 'api/companies';
        Vue.prototype.$CompanyWeekendDays            = process.env.API_URL + 'api/company-weekend-days';
        Vue.prototype.$UpdateCompanyLeaveSetting           = process.env.API_URL + 'api/update-company-leave-setting';
        Vue.prototype.$UpdateRosterSchedule           = process.env.API_URL + 'api/update-roster-schedule';
        Vue.prototype.$Schedule                 = process.env.API_URL + 'api/schedule';
        Vue.prototype.$DeleteScheduleByDate                 = process.env.API_URL + 'api/delete-schedule-by-date';
        Vue.prototype.$AttendaceBySchedule                 = process.env.API_URL + 'api/attendance-by-schedule';
        Vue.prototype.$GetRuleviolationByEmployeeId  = process.env.API_URL + 'api/get-ruleviolation-by-employee';
        Vue.prototype.$NewCompany               = process.env.API_URL + 'api/companies';
        Vue.prototype.$GetListofRoles           = process.env.API_URL + 'api/get-list-data';
        Vue.prototype.$GetRolesList             = process.env.API_URL + 'api/get-role-list';
        Vue.prototype.$DeleteCompany            = process.env.API_URL + 'api/companies/:id';
        Vue.prototype.$EditCompany              = process.env.API_URL + 'api/companies/:id/edit';
        Vue.prototype.$GetCompany               = process.env.API_URL + 'api/companies/:id/edit';
        Vue.prototype.$UpdateCompany            = process.env.API_URL + 'api/companies/:id';
        Vue.prototype.$UpdateCompanyBenefit     = process.env.API_URL + 'api/update-company-benefit';
        Vue.prototype.$UpdateEmployeeBenefit     = process.env.API_URL + 'api/update-employee-benefit';
        Vue.prototype.$UpdateCompnayLogo        = process.env.API_URL + 'api/update-company-logo';
        Vue.prototype.$SaveCompanyBenefit       = process.env.API_URL + 'api/save-company-benefit';
        Vue.prototype.$DeleteCompanyBenefit     = process.env.API_URL + 'api/delete-company-benefit';
        Vue.prototype.$UpdateCompanyJobRoles    = process.env.API_URL + 'api/update-company-job-roles';
        Vue.prototype.$UpdateJobRoles           = process.env.API_URL + 'api/job-roles-update';
        Vue.prototype.$UpdateJobRolesStatus     = process.env.API_URL + 'api/job-roles-update-status';
        Vue.prototype.$DeleteTag                = process.env.API_URL + 'api/delete-multiselect-tag';
        Vue.prototype.$Getlistdata              = process.env.API_URL + 'api/get-list-data';
        Vue.prototype.$makeItShiftAvailable     = process.env.API_URL + 'api/make-shift-available';
        Vue.prototype.$handOverShiftAvailable   = process.env.API_URL + 'api/handover-shift-to-employee';
        Vue.prototype.$UpdateScheduleName   = process.env.API_URL + 'api/update-schedule-name';

        // employee api's routes
        Vue.prototype.$GetEmployees               = process.env.API_URL + 'api/get-all-employee';
        Vue.prototype.$GetAllSalaryComponentsCalculation = process.env.API_URL + 'api/all-salary-components';
        Vue.prototype.$GetEmployeesWithOutSelect  = process.env.API_URL + 'api/get-company-employees-without-select-users';
        Vue.prototype.$SaveEmployee               = process.env.API_URL + 'api/save-employee';
        Vue.prototype.$EmployeeUpdate             = process.env.API_URL + 'api/update-employee';
        Vue.prototype.$DeleteEmployee             = process.env.API_URL + 'api/delete-employee';
        Vue.prototype.$DeleteEmployeeBulk             = process.env.API_URL + 'api/delete-employees-bulk';
        Vue.prototype.$ActivateEmployee           = process.env.API_URL + 'api/activate-employee';
        Vue.prototype.$CheckEmployeeRegNo         = process.env.API_URL + 'api/check-employeeRegNo';
        Vue.prototype.$SaveProfilePicture         = process.env.API_URL + 'api/save-employee-picture';
        Vue.prototype.$SendAgainInvitaionEmail    = process.env.API_URL + 'api/send-again-invitation-email';
        Vue.prototype.$ChangeSelectedComp         = process.env.API_URL + 'api/change-selected-comp';
        Vue.prototype.$GetEmployeeProfile         = process.env.API_URL + 'api/get-employee-profile';
        Vue.prototype.$GetEmployeeShifts          = process.env.API_URL + 'api/get-employee-shift';
        Vue.prototype.$GetEmployeePermissions          = process.env.API_URL + 'api/employee-permissions';
        Vue.prototype.$ReportToSupervisor          = process.env.API_URL + 'api/supervisor';
        Vue.prototype.$GetShift                  = process.env.API_URL + 'api/get-shift';
        Vue.prototype.$TerminateEmployee          = process.env.API_URL + 'api/terminate-employee';
        Vue.prototype.$GetRidOfShiftsAfterLeave   = process.env.API_URL + 'api/get-rid-of-shifts';
        Vue.prototype.$EmployeeShiftForLeave      = process.env.API_URL + 'api/employee-shift-for-leave';
        Vue.prototype.$SaveLeaveData              = process.env.API_URL + 'api/save-employee-leave';
        Vue.prototype.$UpdateLeaveData            = process.env.API_URL + 'api/update-employee-leave';
        Vue.prototype.$CheckLeaveStatus           = process.env.API_URL + 'api/check-leave-status';
        Vue.prototype.$GetAllLeaves               = process.env.API_URL + 'api/get-all-leaves';
        Vue.prototype.$GetLeavesWaiting           = process.env.API_URL + 'api/get-leaves-waiting';
        Vue.prototype.$GetAllRequestData          = process.env.API_URL + 'api/get-all-request-data';
        Vue.prototype.$AcceptOrRejectLeave        = process.env.API_URL + 'api/acceptOrReject-leave';
        Vue.prototype.$setRequestStatus           = process.env.API_URL + 'api/set-request-status';
        Vue.prototype.$Getleave                   = process.env.API_URL + 'api/get-leave';
        Vue.prototype.$DeleteEmplLeave            = process.env.API_URL + 'api/delete-employee-leave';
        Vue.prototype.$CheckEmployeeAttendance    = process.env.API_URL + 'api/check-employee-attendance';
        Vue.prototype.$LeaveApproveReject         = process.env.API_URL + 'api/leave-approve-reject';
        Vue.prototype.$UpdateUserSession          = process.env.API_URL + 'api/user-session-update';
        Vue.prototype.$GiveLeaveAccess            = process.env.API_URL + 'api/give-employee-leave-access';
        Vue.prototype.$getEmployeeWithAttendanceReport  = process.env.API_URL + 'api/get-employee-with-attendance-report';
        Vue.prototype.$TotalgetEmployeeWithAttendanceReport  = process.env.API_URL + 'api/get-total-employee-with-attendance-report';
        //end employee api's routes

        Vue.prototype.$Schedules                          = process.env.API_URL + 'api/schedule';
        Vue.prototype.$pasteSchedulesByDate                          = process.env.API_URL + 'api/pasteSchedulesByDate';
        Vue.prototype.$SchedulesStatusUpdate              = process.env.API_URL + 'api/schedule-status-update';
        Vue.prototype.$GetTotalHoursPerEmployee           = process.env.API_URL + 'api/schedule/total-hours-per-employees';
        Vue.prototype.$Template                           = process.env.API_URL + 'api/template';
        Vue.prototype.$TemplateByDay                      = process.env.API_URL + 'api/get-template-by-day';
        Vue.prototype.$GetShiftCard                       = process.env.API_URL + 'api/get-shift-card';
        Vue.prototype.$GetJobRulesType                    = process.env.API_URL + 'api/job-roles-type';
        Vue.prototype.$JobRolesType                       = process.env.API_URL + 'api/job-roles-type';
        Vue.prototype.$GetEmployeesByJobRolesType         = process.env.API_URL + 'api/employees-by-job-roles-type';
        Vue.prototype.$GetmployeeWithOutByJobRoleId       = process.env.API_URL + 'api/employees-without-job-roles';
        Vue.prototype.$GetEmployeeWithSameRoles           = process.env.API_URL + 'api/employees-with-same-role-type';
        Vue.prototype.$UpdateShiftTime                    = process.env.API_URL + 'api/update-employee-shift-time';
        Vue.prototype.$punchedShiftTime                   = process.env.API_URL + 'api/punched-shift-time';
        Vue.prototype.$DeleteShiftTime                    = process.env.API_URL + 'api/delete-shift-time';
        Vue.prototype.$attendanceLogs                     = process.env.API_URL + 'api/attendance-logs';

        Vue.prototype.$DeleteSchedules                    = process.env.API_URL + 'api/delete-schedules';
        Vue.prototype.$UpdateShift                    = process.env.API_URL + 'api/update-shift';
        Vue.prototype.$DeleteSchedulesByRosterScheduleId  = process.env.API_URL + 'api/delete-schedules-by-roster-schedule-id';
        Vue.prototype.$getPreviousSchedules               = process.env.API_URL + 'api/schedule/previous';
        Vue.prototype.$CopyPreviousScheduleAllShifts  = process.env.API_URL + 'api/copy/previous/schedule/allshifts';
        Vue.prototype.$SchedulePublish                    = process.env.API_URL + 'api/schedule/publish';
        Vue.prototype.$ScheduleTemplateDelete             = process.env.API_URL + 'api/schedule/template/delete';
        Vue.prototype.$GetCountries                       = process.env.API_URL + 'api/get-countries';
        Vue.prototype.$GetCurrencies                      = process.env.API_URL + 'api/get-currencies';
        Vue.prototype.$GeneralRulesViolation              = process.env.API_URL + 'api/general-rules-violation';
        Vue.prototype.$SaveInvitation                     = process.env.API_URL + 'api/save-invitation';
        Vue.prototype.$CompanySpecificTimes                     = process.env.API_URL + 'api/company-specific-times';


        Vue.prototype.$CalculateSalary        = process.env.API_URL + 'api/add-salary';
        Vue.prototype.$CalculatedSalaryLock        = process.env.API_URL + 'api/calculated-salary-lock';
        Vue.prototype.$lockSalarySendNotificationEmp        = process.env.API_URL + 'api/lock-salary-send-notification-emp';
        Vue.prototype.$SaveCalculateSalary        = process.env.API_URL + 'api/save-calculate-salary';
        Vue.prototype.$UpdateCalculateSalary        = process.env.API_URL + 'api/update-calculate-salary';
        Vue.prototype.$GetTaxByAmount         = process.env.API_URL + 'api/get-tax-by-amount';
        Vue.prototype.$CompanyEmployeesList   = process.env.API_URL + 'api/company-employees-list'; // for show data on hours&salary
        Vue.prototype.$getEmployeesSalaries   = process.env.API_URL + 'api/get-salaries'; // get employees salaries
        Vue.prototype.$getProgressBar   = process.env.API_URL + 'api/job-progress-salary'; // get employees salaries
        Vue.prototype.$saveEmployeesSalaries   = process.env.API_URL + 'api/save-employees-salaries'; // save employees salaries
        Vue.prototype.$newSaveEmployeesSalaries = process.env.API_URL + 'api/new-save-employees-salaries';
        Vue.prototype.$NewEmployeeAttendance     = process.env.API_URL + 'api/get-employee-salary-with-attendance';
        Vue.prototype.$GetSalaryCalculationEdit   = process.env.API_URL + 'api/get-salary-calculation-edit'; // for show data on hours&salary
        Vue.prototype.$GetSalaryPeriods       = process.env.API_URL + 'api/get-salary-by-periods';
        Vue.prototype.$DeleteSalaryPeriods       = process.env.API_URL + 'api/delete-salary-by-periods';
        Vue.prototype.$DeleteCompanyConfiremPassword       = process.env.API_URL + 'api/delete-company-confirm-password';
        Vue.prototype.$LockEmail              = process.env.API_URL + 'api/lock-email';
        Vue.prototype.$SalaryList             = process.env.API_URL + 'api/salary-list';    //salarylist
        Vue.prototype.$SalarySlip             = process.env.API_URL + 'api/salary-slip';
        Vue.prototype.$SalaryEmail            = process.env.API_URL + 'api/salary-email';
        Vue.prototype.$DownloadEmployeeSalaryReport            = process.env.API_URL + 'api/employee-salary-report';
        Vue.prototype.$ChangeSalaryEmailStatus = process.env.API_URL + 'api/change-salary-email-status';
        Vue.prototype.$EmployeeInfo           = process.env.API_URL + 'api/employee-info';
        Vue.prototype.$Membership             = process.env.API_URL + 'api/membership';
        Vue.prototype.$CompanyMembership      = process.env.API_URL + 'api/company-membership';
        Vue.prototype.$ComapnyPaymentVerify      = process.env.API_URL + 'api/company-payment-verify';
        Vue.prototype.$PaymentMethod      = process.env.API_URL + 'api/payment-method';
        Vue.prototype.checkoutAlfalaMerchantPayment     = process.env.API_URL + 'api/alfla-merchant-payment';
        Vue.prototype.$PaymentCheckout     = process.env.API_URL + 'api/payment-checkout';
        Vue.prototype.$EmployeeAttendance     = process.env.API_URL + 'api/employee-attendance';

        // new
        Vue.prototype.$getEmployeeLeaves     = process.env.API_URL + 'api/get-employee-leaves';
        Vue.prototype.$getSalaryComponents     = process.env.API_URL + 'api/salary-components';
        Vue.prototype.$saveSalaryComponents   = process.env.API_URL + 'api/save-salary-components';
        Vue.prototype.$DeleteSalaryComponent    = process.env.API_URL + 'api/delete-salary-component';
        // save salary
        Vue.prototype.$SaveSalary = process.env.API_URL + 'api/save-salary';

        Vue.prototype.$getSalaryComponentCalculation   = process.env.API_URL + 'api/salary-components-calculation';
        Vue.prototype.$getSalaryCalculation   = process.env.API_URL + 'api/get-salary-calculation';
        Vue.prototype.$saveSalaryComponentCalculation   = process.env.API_URL + 'api/save-salary-calculation';
        Vue.prototype.$updateSalaryComponentCalculation   = process.env.API_URL + 'api/update-salary-calculation';
        // get single employee salary
        Vue.prototype.$getEmployeeSalary   = process.env.API_URL + 'api/employee-salary';

        Vue.prototype.$DeleteSalaryCalculation    = process.env.API_URL + 'api/delete-salary-calculation';

        Vue.prototype.$TaxSlabs               = process.env.API_URL + 'api/tax-slabs';
        Vue.prototype.$TaxSlabInfo            = process.env.API_URL + 'api/tax-slabs-info';
        Vue.prototype.$CompanyCurrentTaxSlabs            = process.env.API_URL + 'api/company-current-taxslabs';
        Vue.prototype.$TaxSlabsByTaxSlabGroup = process.env.API_URL + 'api/tax-slabs-by-tax-slab-group';

        Vue.prototype.$ResetPassword          = process.env.API_URL + 'api/reset-password';
        Vue.prototype.$VerifyCode             = process.env.API_URL + 'api/verify-request-code';
        Vue.prototype.$getAllAllownces        = process.env.API_URL + 'api/get-employee-allownce';
        Vue.prototype.$designations        = process.env.API_URL + 'api/designations';
        Vue.prototype.$deleteAllownces        = process.env.API_URL + 'api/employee-allownce-delete';
        Vue.prototype.$AddEmployeeBenefit  = process.env.API_URL + 'api/add-employee-benefit';

        Vue.prototype.$AutoGeneratedEmail          = process.env.API_URL + 'api/auto-generated-email';  //email validate
        Vue.prototype.$validateEmail          = process.env.API_URL + 'api/check-email-validate';  //email validate
        Vue.prototype.$validateEmailAndCompany          = process.env.API_URL + 'api/validate-email-and-company';  //email & company name validate
        Vue.prototype.$validatePhone          = process.env.API_URL + 'api/check-availability';  //phone validate
        //--------------------- messages -----------------
        Vue.prototype.$messagesByDate         = process.env.API_URL + 'api/messages/by-date';  //message by date
        Vue.prototype.$messages               = process.env.API_URL + 'api/messages';  //messages
        //-------------------- setting-----------------------
        Vue.prototype.$MakeAdministrator      = process.env.API_URL + 'api/make-administrator';  //Administrator
        Vue.prototype.$SaveCompanyLocation      = process.env.API_URL + 'api/save-company-location';  //Administrator
        Vue.prototype.$RemoveAdministrator    = process.env.API_URL + 'api/remove-administrator';  //Administrator
        Vue.prototype.$GetCompanyAdministrator = process.env.API_URL + 'api/get-company-administrators';  //Administrator
        Vue.prototype.$GetCompanyById = process.env.API_URL + 'api/get-company-by-id';  //Administrator

        Vue.prototype.$allRequestLogs         = process.env.API_URL + 'api/all-request-logs';  //$allEvents
        Vue.prototype.$Logs         = process.env.API_URL + 'api/logs';  //$allEvents
        Vue.prototype.$ReadTheNotification    = process.env.API_URL + 'api/read-notification';  //$allEvents

        Vue.prototype.$WorkShift    = process.env.API_URL + 'api/work-shifts';  //$allEvents
        Vue.prototype.$QuarterWorkShifts    = process.env.API_URL + 'api/quarter-work-shifts';  //$allEvents
        Vue.prototype.$SaveEmployeeShifts    = process.env.API_URL + 'api/save-employee-shift';  //$allEvents



        Vue.prototype.$GetAttendanceEmployee    = process.env.API_URL + 'api/get-attendance-employees';  //$allEvents
        Vue.prototype.$ChangePassword    = process.env.API_URL + 'api/change-password';  //$allEvents

        /* -------------------Timesheet - Projects --------------------*/
      Vue.prototype.$GetProjects    = process.env.API_URL + 'api/projects';
      Vue.prototype.$AddProject    = process.env.API_URL + 'api/projects';
      Vue.prototype.$DeleteProject    = process.env.API_URL + 'api/projects/bulk';
      Vue.prototype.$GetCustomers    = process.env.API_URL + 'api/customers';
      Vue.prototype.$GetAdmins    = process.env.API_URL + 'api/employees';
      Vue.prototype.$GetActivities    = process.env.API_URL + 'api/activities';
      Vue.prototype.$AddActivity    = process.env.API_URL + 'api/activities';
      Vue.prototype.$CopyActivity    = process.env.API_URL + 'api/activities/:id/copy';
      Vue.prototype.$DeleteActivity    = process.env.API_URL + 'api/activities';

      Vue.prototype.$getCustomers                     = process.env.API_URL + 'api/customers';  //$Customername
      Vue.prototype.$createCustomers                  = process.env.API_URL + 'api/customers';  //$CreatecustomerName
      Vue.prototype.$deleteCustomer                   = process.env.API_URL + 'api/customers/bulk';  //$deletecustomerName
      Vue.prototype.$customerUpdate                   = process.env.API_URL + 'api/customers/:id'; //$UpdateCustomer
      Vue.prototype.$StatusTimeSheet                  = process.env.API_URL + 'api/time-sheets/status'; //$timeSheetStatus
      Vue.prototype.$timeSheetDates                   = process.env.API_URL + 'api/time-sheets/dates'; //$timeSheetDates
      Vue.prototype.$postTimeSheetReports             = process.env.API_URL + 'api/time-sheets'; //$timeSheetDates
      Vue.prototype.$getTimeSheetReports              = process.env.API_URL + 'api/time-sheets'; //$timeSheetDates
      Vue.prototype.$getEmployee                      = process.env.API_URL + 'api/time-sheets/employees'; //$timeSheetEmployee
      Vue.prototype.$removeRows                       = process.env.API_URL + 'api/remove-row'; //$remove-row
      Vue.prototype.$getTimeSheetAll                  = process.env.API_URL + 'api/time-sheets/all'; //$timeSheetAll
      Vue.prototype.$getEmployeeTimeSheet             = process.env.API_URL + 'api/time-sheets'; //$timeSheetAll
      Vue.prototype.$GetTimeSheetWeek                 = process.env.API_URL + 'api/time-sheet-by-week';
      Vue.prototype.$GetAttendancesForTimeSheet       = process.env.API_URL + 'api/get-attendances-for-time-sheet';
      Vue.prototype.$UpdateTimeSheetReports           = process.env.API_URL + 'api/update-time-sheet';
      Vue.prototype.$ViewEmployeeTimeSheet            = process.env.API_URL + 'api/view-time-sheet';
      Vue.prototype.$FilterTimeSheet                  = process.env.API_URL + 'api/filter-time-sheet';
      Vue.prototype.$designations                     = process.env.API_URL + 'api/designations';
      /*----------------- Employee Documents--------------------*/
      Vue.prototype.$Documents                       = process.env.API_URL + 'api/documents';
      Vue.prototype.$DocumentStore                       = process.env.API_URL + 'api/documents/store';
      /*---------------- Company Locations ---------------------*/
      Vue.prototype.$locations                       = process.env.API_URL + 'api/locations';
      Vue.prototype.$Holidays                       = process.env.API_URL + 'api/holidays';
      Vue.prototype.$HolidayDates                       = process.env.API_URL + 'api/holiday-dates';
      Vue.prototype.$AssignLocationToEmployee        = process.env.API_URL + 'api/asign-location-to-employee';
      Vue.prototype.$GetEmployeeAssignedLocations    = process.env.API_URL + 'api/get-employee-locations';
      Vue.prototype.$RemoveEmployeeLocation          = process.env.API_URL + 'api/delete-employee-locations';
      Vue.prototype.$RadiusAllowForAttendance        = process.env.API_URL + 'api/attendance-allow-radius';
      Vue.prototype.$GetEmployeesLocations           = process.env.API_URL + 'api/get-locations';
      Vue.prototype.$FilterEmployeesLocations        = process.env.API_URL + 'api/filter-employees-locations';
      Vue.prototype.$CompanyLeaveTypes        = process.env.API_URL + 'api/company-leave-types';
      Vue.prototype.$SpecificEmployeeLeaveTypes        = process.env.API_URL + 'api/get-specific-employee-leave-types';
      Vue.prototype.$EmployeeLeaveEntitlements        = process.env.API_URL + 'api/employee-leave-entitlements';
      Vue.prototype.$CompanyProductItems        = process.env.API_URL + 'api/company-product-items';
      Vue.prototype.$ImportStaff        = process.env.API_URL + 'api/import-staff';

      Vue.prototype.$AttendanceMap    = process.env.API_URL + 'api/get-employees-attendance-map';
      Vue.prototype.$Partners    = process.env.API_URL + 'api/partners';
      Vue.prototype.$benefitCategories    = process.env.API_URL + 'api/benefit-categories';
      Vue.prototype.$benefitCategories    = process.env.API_URL + 'api/benefit-categories';


        Vue.prototype.moment = moment;

        Vue.prototype.getAuthHeader = function () {
            var user_data = this.$store.getters.getUser;
            if (!user_data) {
                return {
                  'Accept'      : 'application/json',
                  'Device-Type' : 'web',
                  'Content-Type': 'application/json'
                };
            }
            return {
              'Authorization' : 'Bearer ' + user_data.accessToken.token,
              'Device-Type'   : 'web', 'Accept': 'application/json',
              'Content-Type'  : 'application/json'
            };
          };

          Vue.prototype.getAuthHeaderForImage = function () {
            var user_data = this.$store.getters.getUser;
            if (!user_data) {
                return {
                  'Accept'      : 'application/json',
                  'Device-Type' : 'web',
                  'Content-Type': 'multipart/form-data'
                };
            }
            return {
              'Authorization' : 'Bearer ' + user_data.accessToken.token,
              'Device-Type'   : 'web',
              "Content-Type": "multipart/form-data"
            };
          };

          Vue.prototype.getImageHeader = function () {
            var user_data = this.$store.getters.getUser;
            if (!user_data) {
              return {
              'Authorization' : 'Bearer ' + user_data.accessToken.token,
              'Accept'        : 'application/json'
            };
            }
            return {
              'Authorization' : 'Bearer ' + user_data.accessToken.token,
              'Device-Type'   : 'web', 'Accept': 'application/json',
              'Content-Type'  : 'multipart/form-data'
            };
        }
        //--------------------calculate hours and minutes---------
      Vue.prototype.calculateHourMinutes = function (startTime, endTime,date) {
        var tomorrowDate  = moment(date).add(1, 'd').format('YYYY-MM-DD');
        var start         = date+" "+startTime;
        var end           = tomorrowDate+" "+endTime;
        var current       = date+" "+endTime;
        if(startTime<endTime){
          var ms  = moment.utc(moment(current,"YYYY-MM-DD HH:mm:ss").diff(moment(start,"YYYY-MM-DD HH:mm:ss"))).format("HH:mm:ss")
        }else{
          var ms  = moment.utc(moment(end,"YYYY-MM-DD HH:mm:ss").diff(moment(start,"YYYY-MM-DD HH:mm:ss"))).format("HH:mm:ss")
        }
        return ms;
      };
      Vue.prototype.calculateHourMinutes2 = function (startTime, endTime,date) {
        var tomorrowDate  = moment(date).add(1, 'd').format('YYYY-MM-DD');
        var start         = date+" "+startTime;
        var end           = tomorrowDate+" "+endTime;
        var current       = date+" "+endTime;
        if(startTime<endTime){
          var ms  = moment.utc(moment(current,"YYYY-MM-DD HH:mm:ss").diff(moment(start,"YYYY-MM-DD HH:mm:ss"))).format("HH:mm")
        }else{
          var ms  = moment.utc(moment(end,"YYYY-MM-DD HH:mm:ss").diff(moment(start,"YYYY-MM-DD HH:mm:ss"))).format("HH:mm")
        }
        return ms;
      };
        //------------------- calculate amount ------------------
        Vue.prototype.getHourlyPriceCalculate = function (hourlyRate, startTime, endTime, name, breakTime,date) {
           var tomorrowDate = moment(date).add(1, 'd').format('YYYY-MM-DD');
          var start         = date+" "+startTime;
          var end           =  tomorrowDate+" "+endTime;
          var current       = date+" "+endTime;
          if(startTime<endTime){
           var ms = moment.utc(moment(current,"YYYY-MM-DD HH:mm:ss").diff(moment(start,"YYYY-MM-DD HH:mm:ss"))).format("HH:mm:ss")
          }else{
           var ms = moment.utc(moment(end,"YYYY-MM-DD HH:mm:ss").diff(moment(start,"YYYY-MM-DD HH:mm:ss"))).format("HH:mm:ss")
          }
          var hoursMinutsSec      = moment.duration(ms);
          var minutes             = hoursMinutsSec.hours() * 60;
          var totalCalMinutes     = (minutes - breakTime) + hoursMinutsSec.minutes();
          var hourRatePerMinutes  = hourlyRate / 60;
          var reHours             = totalCalMinutes / 60;
          var amount              = totalCalMinutes * hourRatePerMinutes;
          if (amount > 0) {
            return amount;
          } else {
            return 0;
          }
        }


      Vue.prototype.filePathCommon=function(file){
        return process.env.API_URL+'/storage/'+file;
      }
      Vue.prototype.getNameFirstLetter=function(name){
        return name && isNaN(name) ? String(name.split(' ')[0]).slice(0,1)+String(name.split(' ')[1]).slice(0,1):'';
      }

      Vue.prototype.routeAndPageAccess=function(employeeData){
        if( employeeData && (employeeData.type=='MANAGER' || (employeeData.type=='EMPLOYEE' && employeeData.managerAccess=='yes'))){
          return true;
        }else{
          return false;
        }
      }
      Vue.prototype.calculateAttendanceTimes=function(attendance) {
        let shiftTime = attendance.schedule.date + ' ' + attendance.schedule.end_time;
        let punchOutTime = '';
        if (attendance.punch_out_time !== '' && moment(attendance.punch_out_time).isValid()) {
          // If punch_out_time is not empty and is a valid date, use it
          punchOutTime = moment(attendance.punch_out_time).format('YYYY-MM-DD HH:mm:ss');
        } else {
          // If punch_out_time is empty or not a valid date, use shift end time
          punchOutTime = moment(shiftTime).format('YYYY-MM-DD HH:mm:ss');
        }
        if (punchOutTime !== '') {
          let attendanceInTime = new Date(attendance.punch_in_time);
          let schudleInTime = new Date(attendance.schedule.date + ' ' + attendance.schedule.start_time);
          let attendanceOutTime = new Date(punchOutTime);
          let schudleOutTime = new Date(attendance.schedule.date + ' ' + attendance.schedule.end_time);
          // Convert dates to timestamps
          attendanceInTime = attendanceInTime.getTime();
          schudleInTime = schudleInTime.getTime();
          attendanceOutTime = attendanceOutTime.getTime();
          schudleOutTime = schudleOutTime.getTime();
          if (attendanceInTime < schudleInTime) {
            attendanceInTime = schudleInTime;
          }
          if (attendanceOutTime > schudleOutTime) {
            attendanceOutTime = schudleOutTime;
          }
          // Calculate the difference in milliseconds
          const differenceInMillis = attendanceOutTime - attendanceInTime;
          // Convert milliseconds to hours
          const differenceInHours = new Date(differenceInMillis).toISOString().substr(11, 5);
          // Now differenceInHours contains the attendance duration in hours
          // console.log('Attendance duration:', differenceInHours, 'hours');
          return differenceInHours;
        }

      }
  Vue.prototype.getEmployeeDetail=function(uuid,companyID){

        this.$axios({
          method: "get",
          params: {
            user_id: uuid,
            company_id: companyID
          },
          url: this.$GetEmployeeProfile,
          headers: this.getAuthHeader()
        }).then(res => {
          if (res.data.status == 200) {
            return  res.data.result[0];
          }else{
            return [];
          }
        });
      }

        Vue.prototype.currencyFormatter = function(value='-') {
          if (value == '-') {
              return value;
          }
          let userCurrency = this.$store.getters.getSelectedCompany.currency !== null ? this.$store.getters.getSelectedCompany.currency.code : 'PKR';
          if (userCurrency != '' || userCurrency != undefined) {

              var parameters =
              {
                currency: 	userCurrency,
                symbol: 	'',
                // locale: 	this.$store.getters.getSelectedCompany.currency.code,
                pattern: 	'#,##0.00 !'
              }
              return OSREC.format(value, parameters);
          }
          return value;
      }
      Vue.filter('toFixed2', function (value) {
        // If the value is a string, try converting it to a number
        const numericValue = typeof value === 'string' ? parseFloat(value) : value;
        // Check if the conversion is successful and the value is a number
        if (!isNaN(numericValue) && typeof numericValue === 'number') {
          // Format the number with two decimal places
          return numericValue.toFixed(2);
        }
        // If the value is not a valid number, return it as is
        return value;
      });
      Vue.prototype.userSessionUpdate = function(){
        this.$axios({
          method  : "POST",
          data    : {},
          url     : this.$UpdateUserSession,
          headers : this.getAuthHeader(),
        }).then((res) => {
          if (res.data.status == 200) {
            this.$store.commit('setUser', res.data.result);
          }
        });
      }

    }
};
